import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Percentage from "../axes/Percentage";

let WeatherClouds = {
    type: "line",
    label: "Clouds",
    fill: false,
    lineTension: 0,
    colorPalette: 0,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Percentage,
    xAxis:Time
};

export default WeatherClouds;



// WEBPACK FOOTER //
// ./src/components/chart/channels/WeatherClouds.js